<template>
  <div id="User">
    <nav class="topnav navbar navbar-expand shadow navbar-light bg-white" id="sidenavAccordion">
      <a href="http://eaglescan.ng" class="navbar-brand d-sm-block" rel="noreferrer">
        <img :src="client.logo" style="height: 30px" alt class="mr-1" />
        <!-- {{ client.shortName }} -->
      </a>

      <ul class="navbar-nav align-items-center ml-auto">
        <li class="nav-item no-caret mr-3">
          <a href="http://eaglescan.ng" class="nav-link dropdown-toggle" rel="noreferrer" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-none d-md-inline font-weight-500">Home</div>
          </a>
        </li>
        <li class="nav-item no-caret mr-3">
          <router-link to="/create" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Create</div> -->
            <div class="d-none d-md-inline font-weight-500">Create</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3">
          <router-link to="/my-tickets" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Tickets</div> -->
            <div class="d-none d-md-inline font-weight-500">My Tickets</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3">
          <router-link to="/faq" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">FAQs</div> -->
            <div class="d-none d-md-inline font-weight-500">FAQs</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3">
          <router-link to="/login" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Login</div> -->
            <div class="d-none d-md-inline font-weight-500">Sign in</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3">
          <router-link to="/signup" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Login</div> -->
            <div class="d-none d-md-inline font-weight-500">Sign up</div>
          </router-link>
        </li>

        <!-- mobile search -->
        <li class="nav-item dropdown no-caret mr-3 mobileMenu">
          <!-- <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-inline d-md-none font-weight-500">
              <i class="fas fa-search"></i>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up py-0 o-hidden" aria-labelledby="navbarDropdownUserImage">
            <div class="dropdown-item">
              <form @submit.prevent="searchHandle" class="form-inline mr-auto d-lg-block">
                <input class="form-control form-control-solid mr-sm-2" type="search" placeholder="Search" aria-label="Search" style="width: auto !important" />
              </form>
            </div>
          </div>-->
        </li>
        <!-- mobile menu -->
        <li class="nav-item dropdown no-caret mr-3 mobileMenu">
          <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-inline d-md-none font-weight-500">
              <i class="fas fa-bars"></i>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
            <router-link to="/create" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i data-feather="settings"></i>
              </div>
              Create
            </router-link>
            <router-link to="/my-tickets" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              My Tickets
            </router-link>
            <router-link to="/faq" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              FAQs
            </router-link>
            <router-link to="/login" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              Login
            </router-link>
            <router-link to="/signup" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              Register
            </router-link>
          </div>
        </li>
      </ul>
    </nav>

    <div id="layoutSidenav">
      <div id="layoutSidenav_content">
        <router-view />

        <!-- footer -->
        <footer class="footer mt-auto footer-light">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 small">{{ copyright }}</div>
              <div class="col-md-6 text-md-right small">
                Powered by
                <a href="https://coregrade.co" target="_blank" rel="noreferrer">Coregrade</a>
              </div>
            </div>
          </div>
        </footer>
        <!-- footer -->
      </div>
    </div>
  </div>
</template>

<script>
import brand from "../helper/brand.js";

export default {
  name: "User",

  mounted() {
    this.$store.dispatch("getClient");
  },

  computed: {
    client() {
      let client = this.$store.state.client;
      if (client.name == "") {
        this.$router.push({ name: "AccountNotFound" });
      }
      return client;
    },

    copyright() {
      let d = new Date();
      return `Copyright ©${d.getFullYear()} ${this.$store.state.client.shortName}`;
    },
  },

  /*   updated() {
    brand.headerGradient(this.client.color, this.client.color2);
  } */
};
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
.page-header-subtitle {
  margin-left: 10px !important;
}
@media (min-width: 576px) {
  .mobileMenu {
    display: none;
  }
}
#layoutSidenav #layoutSidenav_content {
  margin-left: 0;
}
</style>
